import { InvitationAcception } from "@/models/invitation.model";
import axios from "./axios";

export default {
  postAcceptInvitation(payload: InvitationAcception) {
    return axios.get().post("/invitation/accept", payload);
  },
  getInvitations() {
    return axios.get().get("/invitation");
  },
  postResendInvitation(memberId: number) {
    return axios.get().post(`/invitation/${memberId}/resend`);
  }
};
